/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OfficeStats } from './OfficeStats';
import {
    OfficeStatsFromJSON,
    OfficeStatsFromJSONTyped,
    OfficeStatsToJSON,
    OfficeStatsToJSONTyped,
} from './OfficeStats';
import type { ViolationTypeStats } from './ViolationTypeStats';
import {
    ViolationTypeStatsFromJSON,
    ViolationTypeStatsFromJSONTyped,
    ViolationTypeStatsToJSON,
    ViolationTypeStatsToJSONTyped,
} from './ViolationTypeStats';
import type { SettlementAmountStats } from './SettlementAmountStats';
import {
    SettlementAmountStatsFromJSON,
    SettlementAmountStatsFromJSONTyped,
    SettlementAmountStatsToJSON,
    SettlementAmountStatsToJSONTyped,
} from './SettlementAmountStats';
import type { SettlementSummary } from './SettlementSummary';
import {
    SettlementSummaryFromJSON,
    SettlementSummaryFromJSONTyped,
    SettlementSummaryToJSON,
    SettlementSummaryToJSONTyped,
} from './SettlementSummary';
import type { AttorneyStats } from './AttorneyStats';
import {
    AttorneyStatsFromJSON,
    AttorneyStatsFromJSONTyped,
    AttorneyStatsToJSON,
    AttorneyStatsToJSONTyped,
} from './AttorneyStats';

/**
 * 
 * @export
 * @interface SettlementData
 */
export interface SettlementData {
    /**
     * 
     * @type {number}
     * @memberof SettlementData
     */
    totalCases: number;
    /**
     * 
     * @type {string}
     * @memberof SettlementData
     */
    dateRange: string;
    /**
     * 
     * @type {SettlementSummary}
     * @memberof SettlementData
     */
    summary: SettlementSummary;
    /**
     * 
     * @type {Array<OfficeStats>}
     * @memberof SettlementData
     */
    byOffice: Array<OfficeStats>;
    /**
     * 
     * @type {Array<AttorneyStats>}
     * @memberof SettlementData
     */
    byAttorney: Array<AttorneyStats>;
    /**
     * 
     * @type {Array<ViolationTypeStats>}
     * @memberof SettlementData
     */
    byViolationType: Array<ViolationTypeStats>;
    /**
     * 
     * @type {SettlementAmountStats}
     * @memberof SettlementData
     */
    settlementAmounts: SettlementAmountStats;
}

/**
 * Check if a given object implements the SettlementData interface.
 */
export function instanceOfSettlementData(value: object): value is SettlementData {
    if (!('totalCases' in value) || value['totalCases'] === undefined) return false;
    if (!('dateRange' in value) || value['dateRange'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('byOffice' in value) || value['byOffice'] === undefined) return false;
    if (!('byAttorney' in value) || value['byAttorney'] === undefined) return false;
    if (!('byViolationType' in value) || value['byViolationType'] === undefined) return false;
    if (!('settlementAmounts' in value) || value['settlementAmounts'] === undefined) return false;
    return true;
}

export function SettlementDataFromJSON(json: any): SettlementData {
    return SettlementDataFromJSONTyped(json, false);
}

export function SettlementDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettlementData {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCases': json['total_cases'],
        'dateRange': json['date_range'],
        'summary': SettlementSummaryFromJSON(json['summary']),
        'byOffice': ((json['by_office'] as Array<any>).map(OfficeStatsFromJSON)),
        'byAttorney': ((json['by_attorney'] as Array<any>).map(AttorneyStatsFromJSON)),
        'byViolationType': ((json['by_violation_type'] as Array<any>).map(ViolationTypeStatsFromJSON)),
        'settlementAmounts': SettlementAmountStatsFromJSON(json['settlement_amounts']),
    };
}

export function SettlementDataToJSON(json: any): SettlementData {
    return SettlementDataToJSONTyped(json, false);
}

export function SettlementDataToJSONTyped(value?: SettlementData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_cases': value['totalCases'],
        'date_range': value['dateRange'],
        'summary': SettlementSummaryToJSON(value['summary']),
        'by_office': ((value['byOffice'] as Array<any>).map(OfficeStatsToJSON)),
        'by_attorney': ((value['byAttorney'] as Array<any>).map(AttorneyStatsToJSON)),
        'by_violation_type': ((value['byViolationType'] as Array<any>).map(ViolationTypeStatsToJSON)),
        'settlement_amounts': SettlementAmountStatsToJSON(value['settlementAmounts']),
    };
}

